import {NgModule} from '@angular/core';
import {CryptoProCertificateTableComponent} from './crypto-pro-certificate-table.component';
import {GlobalModule} from '@app/core/global.module';
import {AppDialogModule} from '@components/dialog/modules/app-dialog.module';
import {ButtonModule} from '@components/button/modules/button.module';

@NgModule({
    declarations: [
        CryptoProCertificateTableComponent
    ],
    imports: [
        GlobalModule,
    ]
})
export class CryptoProCertificateTableModule {
}
